module.exports = __webpack_public_path__ + "static/media/green-circle.0b8d4ea8.svg";